import React, { useState, useCallback } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
const TITLE = "حاسبة الضغط - احسب الضغط، القوة، أو المساحة";
const DESCRIPTION =
  "حاسبة الضغط الشاملة: احسب الضغط، القوة، أو المساحة باستخدام القيم المدخلة. أداة دقيقة وسهلة الاستخدام.";
const KEYWORDS = "الضغط, حساب الضغط, حساب القوة, حساب المساحة, حاسبة الضغط";
const OG_URL = "https://do-calculate.com/calculator/ar/pressure";
function PressureCalculator() {
  const [pressure, setPressure] = useState("");
  const [force, setForce] = useState("");
  const [area, setArea] = useState("");
  const [calculationMode, setCalculationMode] = useState("calculatePressure");
  const [error, setError] = useState("");
  const [showSteps, setShowSteps] = useState(false);
  const updateCalculations = useCallback(() => {
    setError("");
    const pressureValue = parseFloat(pressure) || 0;
    const forceValue = parseFloat(force) || 0;
    const areaValue = parseFloat(area) || 0;
    switch (calculationMode) {
      case "calculatePressure":
        if (forceValue > 0 && areaValue > 0) {
          const calculatedPressure = forceValue / areaValue;
          setPressure(Math.round(calculatedPressure * 100) / 100);
        } else {
          setError("الرجاء إدخال القوة والمساحة بشكل صحيح");
        }
        break;
      case "calculateForce":
        if (pressureValue > 0 && areaValue > 0) {
          const calculatedForce = pressureValue * areaValue;
          setForce(Math.round(calculatedForce * 100) / 100);
        } else {
          setError("الرجاء إدخال الضغط والمساحة بشكل صحيح");
        }
        break;
      case "calculateArea":
        if (pressureValue > 0 && forceValue > 0) {
          const calculatedArea = forceValue / pressureValue;
          setArea(Math.round(calculatedArea * 100) / 100);
        } else {
          setError("الرجاء إدخال الضغط والقوة بشكل صحيح");
        }
        break;
      default:
        break;
    }
  }, [pressure, force, area, calculationMode]);
  const handleCalculateClick = () => {
    updateCalculations();
    setShowSteps(true);
  };
  const handlePressureChange = (e) => setPressure(e.target.value);
  const handleForceChange = (e) => setForce(e.target.value);
  const handleAreaChange = (e) => setArea(e.target.value);
  const handleModeChange = (e) => setCalculationMode(e.target.value);
  const getSolutionSteps = () => {
    switch (calculationMode) {
      case "calculatePressure":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب الضغط:</h4>
            <ol>
              <li>ادخل القوة (بـ نيوتن) في الحقل المخصص.</li>
              <li>ادخل المساحة (بـ متر مربع) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على الضغط.</li>
              <li>الضغط يساوي القوة / المساحة.</li>
            </ol>
          </div>
        );
      case "calculateForce":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب القوة:</h4>
            <ol>
              <li>ادخل الضغط (بـ باسكال) في الحقل المخصص.</li>
              <li>ادخل المساحة (بـ متر مربع) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على القوة.</li>
              <li>القوة تساوي الضغط × المساحة.</li>
            </ol>
          </div>
        );
      case "calculateArea":
        return (
          <div className="alert alert-info">
            <h4>خطوات حساب المساحة:</h4>
            <ol>
              <li>ادخل الضغط (بـ باسكال) في الحقل المخصص.</li>
              <li>ادخل القوة (بـ نيوتن) في الحقل المخصص.</li>
              <li>اضغط على زر "احسب" للحصول على المساحة.</li>
              <li>المساحة تساوي القوة / الضغط.</li>
            </ol>
          </div>
        );
      default:
        return null;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تتيح لك حاسبة الضغط إجراء ثلاث أنواع من الحسابات استنادًا إلى
                  القيم المدخلة. اختر نوع الحساب المناسب لك وأدخل القيم المتوفرة
                  لحساب القيمة المفقودة بدقة وسهولة.
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد الضغط بمعلومية القوة والمساحة
                </h2>
                <p>
                  إذا كنت تعرف القوة (بـ نيوتن) والمساحة (بـ متر مربع)، يمكنك
                  حساب الضغط (بـ باسكال) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>الضغط = القوة / المساحة</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد القوة بمعلومية الضغط والمساحة
                </h2>
                <p>
                  إذا كنت تعرف الضغط (بـ باسكال) والمساحة (بـ متر مربع)، يمكنك
                  حساب القوة (بـ نيوتن) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>القوة = الضغط × المساحة</b>
                </p>
                <h2 style={{ fontSize: "17px" }}>
                  إيجاد المساحة بمعلومية الضغط والقوة
                </h2>
                <p>
                  إذا كنت تعرف الضغط (بـ باسكال) والقوة (بـ نيوتن)، يمكنك حساب
                  المساحة (بـ متر مربع) باستخدام الصيغة التالية:
                </p>
                <p>
                  <b>المساحة = القوة / الضغط</b>
                </p>
                <p>
                  استخدم هذه الأداة لإدخال القيم المتاحة وحساب القيمة المفقودة
                  بدقة، مما يسهل عليك إجراء الحسابات المتعلقة بالضغط.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div className="form-group align-items-center">
                    <b>
                      <label
                        className="form-label ms-2"
                        htmlFor="calculationMode"
                      >
                        اختر نوع الحساب
                      </label>
                    </b>
                    <div className="d-flex flex-row mb-2">
                      <div>
                        <input
                          type="radio"
                          id="calculatePressure"
                          name="calculationMode"
                          value="calculatePressure"
                          checked={calculationMode === "calculatePressure"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculatePressure" className="ms-2">
                          حساب الضغط
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateForce"
                          name="calculationMode"
                          value="calculateForce"
                          checked={calculationMode === "calculateForce"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateForce" className="ms-2">
                          حساب القوة
                        </label>
                      </div>
                      <div className="ms-3">
                        <input
                          type="radio"
                          id="calculateArea"
                          name="calculationMode"
                          value="calculateArea"
                          checked={calculationMode === "calculateArea"}
                          onChange={handleModeChange}
                        />
                        <label htmlFor="calculateArea" className="ms-2">
                          حساب المساحة
                        </label>
                      </div>
                    </div>
                  </div>
                  <br />
                  {calculationMode !== "calculatePressure" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="forceInput">
                          القوة (نيوتن)
                        </label>
                      </b>
                      <input
                        id="forceInput"
                        type="number"
                        placeholder="1000"
                        value={force}
                        onChange={handleForceChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateForce" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2" htmlFor="areaInput">
                          المساحة (متر مربع)
                        </label>
                      </b>
                      <input
                        id="areaInput"
                        type="number"
                        placeholder="10"
                        value={area}
                        onChange={handleAreaChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  {calculationMode !== "calculateArea" && (
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label
                          className="form-label ms-2"
                          htmlFor="pressureInput"
                        >
                          الضغط (باسكال)
                        </label>
                      </b>
                      <input
                        id="pressureInput"
                        type="number"
                        placeholder="101325"
                        value={pressure}
                        onChange={handlePressureChange}
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  )}
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculateClick}
                  >
                    احسب                  </button>
                  <br/>                  <div>
                    { (
                      <>
                        {error !== "" && (
                          <p className="p-3 mb-2 bg-warning text-white">
                            خطأ: {error}
                          </p>
                        )}
                        {calculationMode === "calculatePressure" &&
                          pressure !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              الضغط (باسكال): {pressure} باسكال
                            </p>
                          )}
                        {calculationMode === "calculateForce" &&
                          force !== "" && (
                            <p className="p-3 mb-2 bg-success text-white">
                              القوة (نيوتن): {force} نيوتن
                            </p>
                          )}
                        {calculationMode === "calculateArea" && area !== "" && (
                          <p className="p-3 mb-2 bg-success text-white">
                            المساحة (متر مربع): {area} متر مربع
                          </p>
                        )}
                        {showSteps && getSolutionSteps()}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
         </div>
</div>
  );
}
export default PressureCalculator;
